import { Turbo } from '@hotwired/turbo-rails';
import * as ActiveStorage from '@rails/activestorage';
import 'bootstrap';

import { Application } from '@hotwired/stimulus';
import { definitions } from 'stimulus:./controllers';

import Sortable from '@stimulus-components/sortable';
import TurboPower from 'turbo_power';

ActiveStorage.start();
TurboPower.initialize(Turbo.StreamActions);

const application = Application.start();
application.load(definitions);
application.register('sortable', Sortable);

// Configure Stimulus development experience
application.debug = false;
window.Stimulus   = application;
